import React from "react";

import { Icon } from "@chakra-ui/react";
import {
  MdBarChart,
  MdPerson,
  MdHome,
  MdLock,
  MdOutlineShoppingCart,
} from "react-icons/md";

// Admin Imports
import Home from "views/admin/default";
import Challenge from "views/admin/challenge";
import About from "views/admin/about";
import MainDashboard from "views/admin/dashboard";
import Profile from "views/admin/profile";
import AssetTables from "views/admin/assetTables";
import QuantifyCyberRisk from "views/admin/quantifyCyberRisk";
import CVETable from "views/admin/cveTable";
import BusinessUnitsTable from "views/admin/businessUnits";
import ChatWithAIVRM from "views/admin/chatWithAIVRM";
import SignOut from "views/auth/signOut"; // Import the SignOut component

// Auth Imports
import SignInCentered from "views/auth/signIn";

const routes = [
  {
    name: "Home",
    layout: "/admin",
    path: "/default",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: Home,
  },
  {
    name: "Challenge",
    layout: "/admin",
    path: "/challenge",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: Challenge,
  },  
  {
    name: "About Us",
    layout: "/admin",
    path: "/about",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: About,
  },
  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "/dashboard",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: MainDashboard,
  },

  {
    name: "Business Lines",
    layout: "/admin",
    path: "/business-units-table",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: BusinessUnitsTable,
  },
  { 
    name: "Assets",
    layout: "/admin",
    path: "/asset-table",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: AssetTables,
  },
  { 
    name: "CVEs",
    layout: "/admin",
    path: "/cve-table",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: CVETable,
  },
  {
    name: "Chat with AIVRM",
    layout: "/admin",
    path: "/chat-aivrm",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: ChatWithAIVRM,
  },
  {
    name: "My Profile",
    layout: "/admin",
    path: "/profile",
    icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
    component: Profile,
  },



  // { 
  //   name: "Asset Table",
  //   layout: "/admin",
  //   path: "/asset-table",
  //   icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
  //   component: AssetTables,
  // },
  
  // { 
  //   name: "CVE Table",
  //   layout: "/admin",
  //   path: "/cve-table",
  //   icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
  //   component: CVETable,
  // },
  // {
  //   name: "Business Units Table",
  //   layout: "/admin",
  //   path: "/business-units-table",
  //   icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
  //   component: BusinessUnitsTable,
  // },
  // {
  //   name: "Chat with AIVRM",
  //   layout: "/admin",
  //   path: "/chat-aivrm",
  //   icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
  //   component: ChatWithAIVRM,
  // },
  // {
  //   name: "Sign Out",
  //   layout: "/auth",
  //   path: "/signOut",
  //   icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
  //   component: SignOut,
  // }

];

export default routes;
